
  var rt = require("@stylable/runtime/dist/css-runtime-stylesheet.js");

  module.exports = rt.create(
      "LottieEmbed1125139890",
      {"classes":{"root":"LottieEmbed1125139890__root","container":"LottieEmbed1125139890__container","svg":"LottieEmbed1125139890__svg"},"vars":{},"stVars":{},"keyframes":{},"layers":{}},
      "",
      -1,
      module.id
  );
  